import { Box, Grid, Title } from '@mantine/core';
import { TutorialLink } from 'components/TutorialLink';
import { Rewards, UsefulResources } from 'components/pages/crowdloan-rewards';
import { useTutorials } from 'hooks/useTutorials';
import type { GetServerSideProps, NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { generateServerProps } from 'utils/server';
import {
  geValidMoonChainKey,
  isQueryParamValid,
} from 'utils/validation/queryParamValidation';

const CrowdloanRewards: NextPage = () => {
  const { t } = useTranslation();
  const { claimRewards } = useTutorials();

  const titleForGA = t('gaTitles.crowdloanRewards');

  return (
    <>
      <Head>
        <meta
          key={'description'}
          name={'description'}
          content={t('descriptions.crowdloanRewards')}
        />
        <title>{titleForGA}</title>
      </Head>
      <Title size={'h2'}>{t('crowdloanRewards')}</Title>
      <Box py={'md'}>
        <TutorialLink link={claimRewards} />
      </Box>
      <Grid>
        <Grid.Col span={{ md: 6, lg: 4 }}>
          <Rewards />
        </Grid.Col>
        <Grid.Col span={{ md: 6, lg: 4 }}>
          <UsefulResources />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default CrowdloanRewards;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  query,
}) => {
  if (!isQueryParamValid(query)) {
    const moonChainKey = geValidMoonChainKey(params?.moonChainKey as string);

    return {
      redirect: {
        destination: `/${moonChainKey}/crowdloan-rewards`,
        permanent: true,
      },
    };
  }

  return await generateServerProps(params?.moonChainKey, locale as string, [
    'common',
    'crowdloan-rewards',
  ]);
};
